const STORAGE_KEY = 'showPrices';

let showPrices = localStorage.getItem(STORAGE_KEY) !== 'false';
const listeners = new Set();

export const getShowPrices = () => showPrices;

export const setShowPrices = (value) => {
  showPrices = Boolean(value);
  localStorage.setItem(STORAGE_KEY, showPrices ? 'true' : 'false');
  listeners.forEach((fn) => fn(showPrices));
};

export const subscribeShowPrices = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
